import { Form, Formik } from "formik";
import { connect } from "react-redux";
import { Col, Modal, Row } from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";

import { inventoryActions, systemActions } from "../../../../redux/actions";
import Button from "../../../../shared/components/Buttons/Button";
import ProductImage from "../../../../assets/images/productimage.png";
import ProductTagList from "../../../../shared/components/tags/ProductTagList";
import CheckboxField from "../../../../shared/components/checkBox/CheckboxField";
import InputNumberField from "../../../../shared/components/inputNumberField/InputNumberField";
import CategoriesDropdown from "../../../../shared/components/selectDropdown/CategoriesDropdown";
import { addNewTradeValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import AddEditInventoryModalPricesHistoryStats from "../../../../shared/components/inventory/AddEditInventoryModalPricesHistoryStats";
import {
  PRODUCT_CONDITIONS_ENUMS,
  PRODUCT_TYPES_ENUMS,
  TRADING_CARD_CATEGORIES_ENUMS,
} from "../../../../system/globalEnums";
import {
  DollarIcon,
  SidebarToggleIcon,
  LogoImageReplaceIcon,
} from "../../../../assets/icons/iconsProvider";
import {
  isTagsEqual,
  customToast,
  handleTagList,
  getShortestSku,
  handleMarginChange,
  handleViewTCGPlayer,
  handleViewEbaySales,
  parseToDecimalNumber,
  getMarginDropdownValue,
  handleViewPriceCharting,
  handleEditBatchConditionChange,
  batchEditChangePriceBaseOnTags,
  parseToThousandSeperatorDecimalNumber,
  handleRaritiesChangeInSingleAddEdit as handleRaritiesChange,
  handleUploadProductImage,
  getProductSubCategory,
  isSystemProduct,
  isSerialNumberUnique,
  getTotalNumberOfInStockProducts,
  isMarketPriceHigh,
  onChangeStockPrice,
  convertToUsd,
  getProductMarketPrice,
  getAddInventoryPartialInitialValues,
  handleIsViewTcgPlayerApiButton,
  getDefaultShopifySettings,
  handleBeautifyMarketPrice,
  handleCashOfferValues,
  handleTradeOfferValues,
} from "../../../../shared/utility";
import {
  toastType,
  EMPTY_STRING,
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  categoryDropdownConstants,
  toggleSwitchButtonConstants,
  toastMessages,
  SHOPIFY_STATUS_OPTIONS,
} from "../../../../constants";
import InputTextField from "../../../../shared/components/inputTextField/InputTextField";
import AddEditInventoryModalProductProperties from "../../../../shared/components/inventory/AddEditInventoryModalProductProperties";
import ConditionWarningText from "../../../../shared/components/inventory/ConditionWarningText";
import { findInventoryProductDetail } from "../../../../shared/inventoryUtility";
import AddEditInventoryModalProductInfo from "../../../../shared/components/inventory/AddEditInventoryModalProductInfo";
import ProductModalHeader from "../../../../shared/components/inventory/ProductModalHeader";
import AddInventoryProductPrices from "../../../../shared/components/inventory/AddInventoryProductPrices";

const BatchTradeEdit = (props) => {
  //-------Props
  const {
    shopify,
    addToCart,
    inventory,
    newTradeData,
    currentStore,
    tradeDiscount,
    activateSpinner,
    deactivateSpinner,
    editProductObject,
    isBatchProductEditModal,
    addTradeBatchInventory,
    priceChartingProductInfo,
    setPriceChartingProductInfo,
    toggleIsBatchProductEditModal,
    setProductShopifySettings,
    initialRatio,
  } = props;
  //-------inventory reducer
  const { productTags, productShopifySettings } = inventory;

  //-------tradeDiscount Reducer
  const { markupPresets, tradeinMargin } = tradeDiscount;

  const { shopifySettings } = shopify;
  //------UseRef
  const hiddenFileInput = useRef(null);

  //-------useState
  const [margin, setMargin] = useState(EMPTY_STRING);
  const [isInStoreQuantity, setIsInStoreQuantity] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [addSelectedTags, setAddSelectedTags] = useState([]);
  const [productUrl, setProductUrl] = useState(EMPTY_STRING);
  const [initialGlobalRatio, setInitialGlobalRatio] = useState(EMPTY_STRING);
  const [rarities, setRarities] = useState(editProductObject?.cardRarityList);
  const [productDataObject, setProductDataObject] = useState(editProductObject);
  const [marginTypeObject, setMarginTypeObject] = useState(
    editProductObject?.tradeInMarginTypeObject || {}
  );
  const [isTradiingCardWarningText, setIsTradiingCardWarningText] =
    useState(false);
  const [productTagsList, setProductTagsList] = useState(
    handleTagList(
      productTags,
      productDataObject?.genre,
      editProductObject?.productCondition,
      inventoryConstants.NINTENDO_CATEGORIES.includes(
        productDataObject?.consoleName
      ) ||
        inventoryConstants.SKYLANDER_CATEGORIES.includes(
          productDataObject?.consoleName
        )
        ? editProductObject?.productCondition ===
          PRODUCT_CONDITIONS_ENUMS.COMPLETE
          ? inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL
          : inventoryConstants.PRODUCT_TAGS.WITH_MANUAL
        : ""
    ) || []
  );
  const [productType, setProductType] = useState(
    editProductObject?.productType
  );
  const [selectedRarity, setSelectedRarity] = useState(
    editProductObject?.cardRarity
  );
  const [productCondition, setProductCondition] = useState(
    editProductObject?.productCondition
      ? {
          value: editProductObject?.productCondition,
          label: editProductObject?.productCondition,
        }
      : {}
  );

  //-------Initial Values
  const initialValues = {
    box:
      productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE &&
      selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.WITH_BOX),
    manual:
      (productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE &&
        !selectedTags?.includes(
          inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL
        )) ||
      (productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE &&
        selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.WITH_MANUAL)),
    cables:
      (productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
        productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE) &&
      !selectedTags?.includes(inventoryConstants.PRODUCT_TAGS.MISSING_WIRES),
    controller:
      (productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
        productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE) &&
      !selectedTags?.includes(
        inventoryConstants.PRODUCT_TAGS.MISSING_CONTROLLER
      ),
    costOfGoods: productDataObject?.costOfGoods || EMPTY_STRING,
    inStockPrice: productDataObject?.inStockPrice || EMPTY_STRING,
    ...getAddInventoryPartialInitialValues(
      {
        ...productDataObject,
        ...editProductObject,
        quantity:
          editProductObject?.inStockQuantity ??
          productDataObject?.inStockQuantity ??
          1,
      },
      true
    ),
  };
  //-------Functions
  //-------Handle Hide Modal
  const handleHideModal = () => {
    setPriceChartingProductInfo(EMPTY_STRING);
    toggleIsBatchProductEditModal();
  };

  //-------Handle Replace Image Button Click
  const handleReplaceButtonClick = () => {
    hiddenFileInput.current.click();
  };

  //------- toggle InStore Quantity
  const toggleIsInStoreQuantity = () => {
    setIsInStoreQuantity((prev) => !prev);
  };

  //-------Handle Submit
  const handleSubmit = (values) => {
    //------- filter products from current batch with same productId and Skip the current Product
    const batchProducts = addTradeBatchInventory?.filter(
      (product) =>
        product?.productId === editProductObject?.productId &&
        product?.id !== editProductObject?.id
    );

    const cartProducts =
      newTradeData?.inventory?.filter(
        (product) => product?.product_id === editProductObject?.productId
      ) || [];

    if (!productDataObject?.productName) {
      customToast("Please select some product", toastType.ERROR);
    } else if (
      isSystemProduct(getProductSubCategory(productDataObject?.genre)) &&
      !isSerialNumberUnique(values.serialNumber, [
        ...(editProductObject?.productsAvailableInInventory || []),
        ...(batchProducts || []),
        ...(cartProducts || []),
      ])
    ) {
      customToast(
        toastMessages.PRODUCT_SERIAL_NUMBER_SHOULD_BE_UNIQUE,
        toastType.ERROR
      );
    } else if (
      values?.serialNumber &&
      (values.isSeparateQuantity
        ? values.onlineQuantity > 1
        : values.quantity > 1)
    ) {
      customToast(toastMessages.SYSTEM_QUANTITY_MUST_BE_1, toastType.ERROR);
      return;
    } else {
      const sendToData = {
        ...productDataObject,
        ...values,
        id: productDataObject?.id,
        productId: productDataObject.productId,
        productName: productDataObject.productName,
        consoleName: productDataObject.consoleName,
        marketPrice: productDataObject.marketPrice,
        suggestedSellPrice: productDataObject.suggestedSellPrice,
        costOfGoods: values.costOfGoods,
        inStockPrice: values.inStockPrice,
        inStockQuantity: values.quantity,
        skuNumber: 0,
        gameStopBuyPrice: productDataObject.gameStopBuyPrice,
        averageBuyPrice: productDataObject.averageBuyPrice,
        averageSellPrice: productDataObject.averageSellPrice,
        maxBuyPrice: productDataObject.maxBuyPrice,
        imgUrl: productDataObject?.imgUrl,
        productCondition: productCondition?.value,
        cardRarity: selectedRarity || EMPTY_STRING,
        tags: addSelectedTags?.map((tag) => tag),
        tradeInMarginTypeObject: marginTypeObject,
        cashOffer: values.isSeparateQuantity
          ? values.onlineCashOffer
          : values.cashOffer,
        tradeOffer: values.isSeparateQuantity
          ? values.onlineTradeOffer
          : values.tradeOffer,
        serialNumber: values.serialNumber,
        isLinkToShopify: productDataObject.isLinkToShopify,
      };
      addToCart(sendToData);
      handleHideModal();
    }
  };

  //-------handle tag select or unselect
  const onSelectTagsChange = (selectedTags) => {
    const selectedTagList = selectedTags.map((tag) => tag);
    const selectedTagListTags = selectedTags.map((tag) => tag.label);
    batchEditChangePriceBaseOnTags(
      selectedTagList,
      productDataObject,
      setProductDataObject,
      productCondition,
      productType,
      tradeinMargin,
      markupPresets,
      true
    );

    setSelectedTags(selectedTagListTags);
    setAddSelectedTags(selectedTagList);
  };

  //-------- handle custom margin
  const handleMarginSelectChange = (selectedOption, setFieldValue) => {
    setInitialGlobalRatio("");
    handleMarginChange(
      setMargin,
      productDataObject?.marketPrice,
      productDataObject?.productType,
      setFieldValue,
      selectedOption,
      tradeinMargin,
      {
        ...productDataObject,
        cardRarity: selectedRarity,
        condition: productCondition?.value,
        tags: selectedTags?.map((tag) => tag.label) || [],
      },
      setMarginTypeObject
    );
  };

  const handleShopifyStatusChange = (option) => {
    setProductDataObject((prevState) => ({
      ...prevState,
      isLinkToShopify: option.value,
    }));
  };

  //-------Handle Shopfiy Collection & Online Quantity Check Change
  const handleStoreAndOnlineQuantityChange = (value, setFieldValue) => {
    setProductDataObject((prevState) => ({
      ...prevState,
      isOnlineQuantity: value,
    }));
    setFieldValue("isOnlineQuantity", value);
  };

  //-------useEffects
  useEffect(() => {
    if (productCondition?.value) {
      findInventoryProductDetail(
        productCondition?.value,
        priceChartingProductInfo?.productMetaData?.cardRarity,
        selectedTags,
        editProductObject,
        productDataObject,
        setProductDataObject,
        priceChartingProductInfo,
        setPriceChartingProductInfo,
        currentStore,
        markupPresets,
        true
      );
    }
  }, [
    selectedTags,
    priceChartingProductInfo?.productMetaData?.cardRarity,
    productCondition,
  ]);

  useEffect(() => {
    if (productShopifySettings?.marginObject?.id) {
      setProductDataObject((prev) => ({
        ...prev,
        shopifySettingId: productShopifySettings?.marginObject?.id,
      }));
    }
  }, [productShopifySettings]);

  useEffect(() => {
    setProductShopifySettings(addTradeBatchInventory[0]?.shopifySettingsObject);
  }, [addTradeBatchInventory?.shopifySettingsObject]);

  //-------Return batch Edit Component
  return (
    <Modal
      show={isBatchProductEditModal}
      size="xl"
      onHide={handleHideModal}
      animation={true}
      centered
      backdrop="static"
      className={`add-inventory-modal ${productUrl ? "iframe-opened" : ""}`}
    >
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validate={(values) =>
          addNewTradeValidationSchema(
            values,
            currentStore?.[
              toggleSwitchButtonConstants.IS_SERIAL_NUMBER_REQUIRED_INVENTORY
            ] &&
              getProductSubCategory(productDataObject?.genre) ===
                TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
          )
        }
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Modal.Header
              closeButton
              className="add-inventory-modal-header  pt-0 pb-1"
            >
              <Modal.Title>
                <span className="add-inventory-modal-header-name">
                  Edit Batch Inventory
                </span>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="add-inventory-modal-body d-flex ">
              <Row className={`m-0 ${productUrl ? "w-50" : "w-100"}`}>
                <Col xs={12} className="add-inventory-hero-wrapper px-0">
                  <Row className="m-0">
                    {/* Product image, meta data and Open Iframe Buttons */}
                    <ProductModalHeader
                      values={values}
                      isEditModal={true}
                      productTags={productTags}
                      selectedTags={selectedTags}
                      setProductUrl={setProductUrl}
                      activateSpinner={activateSpinner}
                      hiddenFileInput={hiddenFileInput}
                      productDataObject={productDataObject}
                      deactivateSpinner={deactivateSpinner}
                      setProductDataObject={setProductDataObject}
                      handleReplaceButtonClick={handleReplaceButtonClick}
                      priceChartingProductInfo={priceChartingProductInfo}
                      handleConditionChange={handleEditBatchConditionChange}
                      setAddSelectedTags={setAddSelectedTags}
                      markupPresets={markupPresets}
                      tradeinMargin={tradeinMargin}
                      setProductTagsList={setProductTagsList}
                      setSelectedTags={setSelectedTags}
                      setFieldValue={setFieldValue}
                      setConditionList={(e) => {
                        setProductDataObject({
                          ...productDataObject,
                          conditionList: e,
                          productConditionList: e,
                        });
                      }}
                      productCondition={productCondition}
                      setProductCondition={setProductCondition}
                      setPriceChartingProductInfo={setPriceChartingProductInfo}
                      isConvertToUsd={true}
                    />

                    {/* <Col md={12} className="gap-3 mt-3 pt-2">
                      <AddEditInventoryModalProductProperties
                        values={values}
                        setFieldValue={setFieldValue}
                        priceChartingProductInfoComponent={productDataObject}
                        setPriceChartingProductInfoComponent={
                          setProductDataObject
                        }
                        conditionComponent={{
                          setConditionList: (e) => {
                            setProductDataObject({
                              ...productDataObject,
                              conditionList: e,
                              productConditionList: e,
                            });
                          },
                          productCondition: productCondition,
                          setProductCondition: setProductCondition,
                          component: (
                            <CategoriesDropdown
                              options={
                                productDataObject?.productConditionList || []
                              }
                              handleChange={(selectedOption) =>
                                handleEditBatchConditionChange(
                                  markupPresets,
                                  selectedOption,
                                  setProductCondition,
                                  productTags,
                                  setProductTagsList,
                                  setProductDataObject,
                                  productDataObject,
                                  setSelectedTags,
                                  tradeinMargin,
                                  setAddSelectedTags,
                                  true,
                                  setPriceChartingProductInfo
                                )
                              }
                              noOptionsMessage="No Condition Found"
                              placeholder="Condition"
                              SelectIconImage={
                                categoryDropdownConstants.INVENTORY_LIST_ICON
                              }
                              isClearable={false}
                              className="add-inventory-dropdowns-category condition-dropdown"
                              value={productCondition}
                            />
                          ),
                        }}
                        // raritiesComponent={{
                        //   handleRaritiesChange: (selectedOption) => {
                        //     handleRaritiesChange(
                        //       selectedOption,
                        //       setSelectedRarity,
                        //       setProductDataObject,
                        //       productDataObject,
                        //       tradeinMargin,
                        //       markupPresets,
                        //       true
                        //     );
                        //   },
                        // }}
                      />
                    </Col> */}
                    {productCondition?.value ===
                      PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                    productCondition?.value ===
                      PRODUCT_CONDITIONS_ENUMS.LOOSE ? (
                      <Col
                        md={12}
                        className="d-flex align-items-center gap-3 my-2"
                      >
                        {productDataObject.genre ===
                        TRADING_CARD_CATEGORIES_ENUMS.SYSTEM ? (
                          productCondition?.value ===
                          PRODUCT_CONDITIONS_ENUMS.COMPLETE ? (
                            <>
                              <CheckboxField name="manual" label="Manual" />
                              {/* <CheckboxField name="box" label="Box" /> */}
                              <CheckboxField name="cables" label="Cables" />
                              <CheckboxField
                                name="controller"
                                label="Controller"
                              />
                            </>
                          ) : productCondition?.value ===
                            PRODUCT_CONDITIONS_ENUMS.LOOSE ? (
                            <>
                              <CheckboxField name="manual" label="Manual" />
                              <CheckboxField name="cables" label="Cables" />
                              <CheckboxField
                                name="controller"
                                label="Controller"
                              />
                            </>
                          ) : (
                            ""
                          )
                        ) : [
                            ...inventoryConstants.NINTENDO_CATEGORIES,
                            ...inventoryConstants.SKYLANDER_CATEGORIES,
                          ].includes(editProductObject?.consoleName) ? (
                          ""
                        ) : (
                          <CheckboxField name="manual" label="Manual" />
                        )}
                      </Col>
                    ) : (
                      ""
                    )}

                    <Col
                      md={12}
                      className="my-2 d-flex align-items-center gap-4"
                    >
                      <ProductTagList
                        className={"align-items-center"}
                        tagsList={productTagsList || []}
                        suggestedArrayList={productTags}
                        onSelectTagsChange={onSelectTagsChange}
                        productDetail={productDataObject}
                        productCondition={productCondition}
                        selectedManual={{
                          isChecked: values.manual,
                          value:
                            productCondition?.value ===
                            PRODUCT_CONDITIONS_ENUMS.COMPLETE
                              ? inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL
                              : productCondition?.value ===
                                PRODUCT_CONDITIONS_ENUMS.LOOSE
                              ? inventoryConstants.PRODUCT_TAGS.WITH_MANUAL
                              : "",
                        }}
                        selectedWires={{
                          isChecked: values.cables,
                          value:
                            PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                            productCondition?.value ===
                              PRODUCT_CONDITIONS_ENUMS.LOOSE
                              ? inventoryConstants.PRODUCT_TAGS.MISSING_WIRES
                              : "",
                        }}
                        selectedController={{
                          isChecked: values.controller,
                          value:
                            PRODUCT_CONDITIONS_ENUMS.COMPLETE ||
                            productCondition?.value ===
                              PRODUCT_CONDITIONS_ENUMS.LOOSE
                              ? inventoryConstants.PRODUCT_TAGS
                                  .MISSING_CONTROLLER
                              : "",
                        }}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} className="m-0 p-0 mt-4">
                  <Row className="m-0">
                    <Col md={4} className="px-0">
                      <AddEditInventoryModalPricesHistoryStats
                        defaultStatus={SHOPIFY_STATUS_OPTIONS[0]}
                        productDataObject={productDataObject}
                        propertyNameOfStatCardsToHide={["totalUnitsSold"]}
                        handleShopifyStatusChange={handleShopifyStatusChange}
                        isShowInStoreOnlineQuantityCheck={true}
                        handleStoreAndOnlineQuantityChange={(value) =>
                          handleStoreAndOnlineQuantityChange(
                            value,
                            setFieldValue
                          )
                        }
                      />
                    </Col>
                    <Col md={8}>
                      <Row className="m-0  h-100">
                        <AddInventoryProductPrices
                          values={values}
                          productTags={productTags}
                          productType={productType}
                          selectedTags={selectedTags}
                          currentStore={currentStore}
                          setFieldValue={setFieldValue}
                          markupPresets={markupPresets}
                          marginTypeObject={marginTypeObject}
                          isInStoreQuantity={isInStoreQuantity}
                          productDataObject={productDataObject}
                          toggleIsInStoreQuantity={toggleIsInStoreQuantity}
                          priceChartingProductInfo={priceChartingProductInfo}
                          isTradeInProduct={true}
                          tradeinMargin={tradeinMargin}
                          productCondition={productCondition}
                          setMarginTypeObject={setMarginTypeObject}
                          handleMarginChange={handleMarginChange}
                          handleTradeOfferValues={handleTradeOfferValues}
                          handleCashOfferValues={handleCashOfferValues}
                          isBatchEdit={true}
                          initialRatio={initialRatio}
                          productUrl={productUrl}
                        />
                        <Col md={12} className="d-flex align-items-end gap-2">
                          <Button
                            label={buttonNameConstants.CANCEL}
                            className="w-100"
                            type="button"
                            handleClick={() => handleHideModal()}
                            buttonType={buttonTypeConstants.GHOST_BUTTON}
                          />
                          <Button
                            label={buttonNameConstants.SAVE}
                            className="w-100"
                            type="submit"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {productUrl && (
                <Row className="m-0 w-50">
                  <Col md={12}>
                    {productUrl && (
                      <iframe
                        title="Product Iframe"
                        src={productUrl}
                        className="iframe-website"
                      />
                    )}
                  </Col>
                </Row>
              )}
            </Modal.Body>
          </Form>
        )}
      </Formik>
      {productUrl && (
        <button
          type="button"
          onClick={() => {
            setProductUrl("");
          }}
          className="iframe-toogle-button"
        >
          <SidebarToggleIcon className={"iframe-toggle-icon"} />
        </button>
      )}
    </Modal>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  inventory: state.inventory,
  shopify: state.shopify,
  tradeDiscount: state.tradeDiscount,
  currentStore: state.store.currentStore,
  addTradeBatchInventory: state.transaction.addTradeBatchInventory,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
  setProductShopifySettings: (data) =>
    dispatch(inventoryActions.setProductShopifySettings(data)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(BatchTradeEdit);
